import moment from 'moment'

export const durations = [
  moment.duration(1, 'day').asMilliseconds(),
  moment.duration(1, 'week').asMilliseconds(),
  moment.duration(1, 'month').asMilliseconds(),
  moment.duration(3, 'month').asMilliseconds(),
  moment.duration(6, 'month').asMilliseconds(),
  moment.duration(1, 'year').asMilliseconds(),
]

export const DEFAULT_DURATION = durations[0]

const toTimestamp = v => moment(v).valueOf()

/**
 * Returns `true` when:
 * - `startDate` is between `from` and `to`, if `endDate` is falsy,
 * - `startDate` and `endDate` are between `from` and `to`, if `endDate` is not falsy.
 *
 * Returns `false` in any other case.
 *
 * @param {String|Date|number} startDate - start date or timestamp
 * @param {String|Date|number} [endDate] - end date or timestamp
 * @param {String|Date|number} from - period beginning as a date or timestamp
 * @param {String|Date|number} to - period end as a date or timestamp
 * @returns {boolean}
 */
export const isContainedInPeriod = ({ startDate, endDate }, { from, to }) => {
  return !!(startDate >= from && (!to || (endDate && endDate <= to)))
}

/**
 * Calculates enclosing period of item.
 *
 * @param {String|Date|number} startDate - start date or timestamp
 * @param {String|Date|number} [endDate] - end date or timestamp
 * @returns {*[]}
 */
export const calculateEnclosingPeriod = ({ startDate, endDate }, { from, to } = {}) => {
  const startTime = startDate && toTimestamp(startDate)
  const endTime = endDate && toTimestamp(endDate)
  const fromTime = from && toTimestamp(from)
  const toTime = to && toTimestamp(to)

  return {
    from: new Date(fromTime <= startTime ? fromTime : startTime),
    ...(endTime && toTime ? { to: new Date(toTime >= endTime ? toTime : endTime) } : {}),
  }
}

/**
 * Checks if the given date is in the given period.
 * @param from The period from value.
 * @param to The period to value.
 * @param {String=second} precision The precision to apply
 * @return {function(*=): boolean}
 */
export const isDateInPeriod = ({ from, to }, precision = 'second') => date =>
  moment(from)
    .startOf(precision)
    .isSameOrBefore(moment(date).startOf(precision)) &&
  moment(to)
    .endOf(precision)
    .isSameOrAfter(moment(date).endOf(precision))
